import { lt as reactlt } from '@ews/react-translations';

const lt = {
...reactlt
}
export default lt
